import React from "react";
//#region types
import { EditableRowDraggableProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import EditableTableRow from "./row";
import useDraggableRow from "../../hooks/useDraggableRow";
//#endregion

const EditableTableRowDraggable: React.FC<EditableRowDraggableProps> = (props) => {
  const { rowIndex, isAddNewRow, moveRow, hoverRow, row, idFieldKey } = props;

  const { dropRef, isDragging, handlerId } = useDraggableRow(
    row[idFieldKey ?? "id"],
    rowIndex,
    isAddNewRow,
    moveRow,
    hoverRow
  );

  return <EditableTableRow {...props} dropRef={dropRef} isDragging={isDragging} handlerId={handlerId} />;
};

export default EditableTableRowDraggable;
